import { pushDataLayerEvent } from "./tracking";
import { TriggerManager } from "./TriggerManager";

export const initOskarTriggers = async () => {
    if (!window.OskarTS) {
        console.error("Can't initialize Oskar triggers without Oskar library");
        return;
    }
    new TriggerManager({ capture: pushDataLayerEvent }).initialize();
};
